"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCredentials = exports.xcsrfToken = exports.checkErrors = exports.applicationId = exports.xb3TraceId = exports.xb3TraceIdServer = exports.customerId = exports.baseUrl = exports.hackChannelId = exports.channelId = void 0;
var headers_1 = require("../constants/headers");
var get_csrf_cookie_name_1 = require("../lib/get-csrf-cookie-name");
var get_random_trace_id_1 = require("./get-random-trace-id");
/**
 * Добавляет заголовок `Channel-ID` ко всем запросам.
 * Нужен для всех апишек мобайла.
 * @param channelId для клика `C2`
 */
exports.channelId = function (config, param) {
    var _a;
    if (param === void 0) { param = {}; }
    return (__assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), (_a = {}, _a[headers_1.AdditionalHeaders.channelId] = param.channelId || '', _a)) }));
};
/**
 * Позволяет добавлять заголовок Hack-Channel-ID к запросам
 * На ноде эти заголовки будут передаваться как Channel-ID в мидл
 * Это временная мера
 * Не используйте это если не знаете что делаете
 * @param defaultChannelId
 */
exports.hackChannelId = function (defaultChannelId) {
    var configExtender = function (config, param) {
        var _a;
        if (param === void 0) { param = {}; }
        return (__assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), (_a = {}, _a[headers_1.AdditionalHeaders.hackChannelId] = param.channelId || defaultChannelId || '', _a)) }));
    };
    return configExtender;
};
/**
 * Добавляет базовый url ко всем запросам
 * @param baseURL Base url для апи
 */
function baseUrl(baseURL) {
    var configExtender = function (config) { return (__assign(__assign({}, config), { baseURL: baseURL })); };
    return configExtender;
}
exports.baseUrl = baseUrl;
/**
 * Добавляет идентификатор пользователя в заголовки
 * @param config Конфиг который расширится перед отправкой на сервер
 * @param param Параметры которые передадутся в вызов сервиса
 */
exports.customerId = function (config, param) {
    var _a;
    if (param === void 0) { param = {}; }
    return (__assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), (_a = {}, _a[headers_1.AdditionalHeaders.cus] = param.customerId || '', _a)) }));
};
/**
 * Устанавливает XB3-trace-id заголовок
 */
exports.xb3TraceIdServer = function (config, _a) {
    var _b;
    var traceId = (_a === void 0 ? {} : _a).traceId;
    return (__assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), (_b = {}, _b[headers_1.AdditionalHeaders.traceId] = traceId || get_random_trace_id_1.getRandomTraceId(), _b[headers_1.AdditionalHeaders.spanId] = get_random_trace_id_1.getRandomTraceId(), _b)) }));
};
/**
 * Генерирует X-B3-TraceId и добавляет в заголовки
 */
exports.xb3TraceId = function (config) {
    var _a;
    return (__assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), (_a = {}, _a[headers_1.AdditionalHeaders.traceId] = get_random_trace_id_1.getRandomTraceId(), _a[headers_1.AdditionalHeaders.spanId] = get_random_trace_id_1.getRandomTraceId(), _a)) }));
};
/**
 * Добавляет applicationId заголовок к запрос
 * @param appId applicationId приложения с которого уходит запрос
 */
function applicationId(appId) {
    var configExtender = function (config) { return (__assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), { applicationId: appId }) })); };
    return configExtender;
}
exports.applicationId = applicationId;
function checkErrors(response) {
    if (response.status < 200 || response.status >= 300) {
        // eslint-disable-next-line no-console
        console.error(response.statusText);
    }
    if (response.status === 204 || response.status === 205) {
        return null;
    }
    return response.data;
}
exports.checkErrors = checkErrors;
/**
 * Устанавливает заголовок `X-CSRF-Token`
 */
exports.xcsrfToken = function (appId) {
    var configExtender = function (config) { return (__assign(__assign({}, config), { xsrfCookieName: get_csrf_cookie_name_1.getCsrfCookieName(appId), xsrfHeaderName: headers_1.AdditionalHeaders.xsrf })); };
    return configExtender;
};
/**
 * Устанавливает параметр `withCredentials`, необходимо для кросс-доменных запросов
 */
exports.withCredentials = function (config) { return (__assign(__assign({}, config), { withCredentials: true })); };

//# sourceMappingURL=extensions.js.map
